import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* CTA Section */}
        <div className="footer-cta">
          <div className="footer-cta-bg">
            <img
              src="https://images.unsplash.com/photo-1516690561799-46d8f74f9abf?w=1920&q=80"
              alt=""
              aria-hidden="true"
              loading="lazy"
            />
          </div>
          <div className="footer-cta-content">
            <h2 className="footer-cta-title">Ready to Explore Nepal?</h2>
            <p className="footer-cta-text">
              Join thousands of players testing their knowledge of Nepal's incredible geography.
            </p>
            <div className="footer-cta-buttons">
              <Link to="/register" className="btn-cta-primary">Get Started Free</Link>
              <Link to="/leaderboard" className="btn-cta-secondary">View Leaderboard</Link>
            </div>
          </div>
        </div>

        <div className="footer-content">

          {/* Links Sections */}
          <div className="footer-links">
            <div className="footer-section">
              <h4>Game</h4>
              <Link to="/game">Play Solo</Link>
              <Link to="/multiplayer">Multiplayer</Link>
              <Link to="/leaderboard">Leaderboard</Link>
            </div>

            <div className="footer-section">
              <h4>Account</h4>
              <Link to="/login">Log In</Link>
              <Link to="/register">Sign Up</Link>
              <Link to="/dashboard">Dashboard</Link>
            </div>

           
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} MapHunt. All rights reserved.</p>
          <p className="footer-made">
            Made with <Heart size={13} className="heart" /> for Nepal
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
